export default "__VITE_ASSET__DYjPrxFZ__"